/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateUnitTypeRequest,
  ErrorResponse,
  UnitType,
} from '../models/index';
import {
    CreateUnitTypeRequestFromJSON,
    CreateUnitTypeRequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    UnitTypeFromJSON,
    UnitTypeToJSON,
} from '../models/index';

export interface CreateUnitTypeOperationRequest {
    createUnitTypeRequest: CreateUnitTypeRequest;
}

export interface DeleteUnitTypeRequest {
    id: string;
}

export interface GetUnitTypeByIdRequest {
    id: string;
}

export interface UpdateUnitTypeRequest {
    id: string;
    createUnitTypeRequest: CreateUnitTypeRequest;
}

/**
 * 
 */
export class UnitTypesApi extends runtime.BaseAPI {

    /**
     * Create a new unit type
     * Create a new unit type
     */
    async createUnitTypeRaw(requestParameters: CreateUnitTypeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnitType>> {
        if (requestParameters['createUnitTypeRequest'] == null) {
            throw new runtime.RequiredError(
                'createUnitTypeRequest',
                'Required parameter "createUnitTypeRequest" was null or undefined when calling createUnitType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/unit-types`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUnitTypeRequestToJSON(requestParameters['createUnitTypeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UnitTypeFromJSON(jsonValue));
    }

    /**
     * Create a new unit type
     * Create a new unit type
     */
    async createUnitType(requestParameters: CreateUnitTypeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnitType> {
        const response = await this.createUnitTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a unit type
     * Delete unit type
     */
    async deleteUnitTypeRaw(requestParameters: DeleteUnitTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteUnitType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/unit-types/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a unit type
     * Delete unit type
     */
    async deleteUnitType(requestParameters: DeleteUnitTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUnitTypeRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve a list of all unit types
     * Get all unit types
     */
    async getAllUnitTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UnitType>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/unit-types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UnitTypeFromJSON));
    }

    /**
     * Retrieve a list of all unit types
     * Get all unit types
     */
    async getAllUnitTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UnitType>> {
        const response = await this.getAllUnitTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a unit type by its ID
     * Get unit type by ID
     */
    async getUnitTypeByIdRaw(requestParameters: GetUnitTypeByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnitType>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getUnitTypeById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/unit-types/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UnitTypeFromJSON(jsonValue));
    }

    /**
     * Retrieve a unit type by its ID
     * Get unit type by ID
     */
    async getUnitTypeById(requestParameters: GetUnitTypeByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnitType> {
        const response = await this.getUnitTypeByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing unit type
     * Update unit type
     */
    async updateUnitTypeRaw(requestParameters: UpdateUnitTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnitType>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateUnitType().'
            );
        }

        if (requestParameters['createUnitTypeRequest'] == null) {
            throw new runtime.RequiredError(
                'createUnitTypeRequest',
                'Required parameter "createUnitTypeRequest" was null or undefined when calling updateUnitType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/unit-types/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUnitTypeRequestToJSON(requestParameters['createUnitTypeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UnitTypeFromJSON(jsonValue));
    }

    /**
     * Update an existing unit type
     * Update unit type
     */
    async updateUnitType(requestParameters: UpdateUnitTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnitType> {
        const response = await this.updateUnitTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
